import ApiService from '@/core/services/api.service'

//action types
export const GET_BANCOS = "getBancos";
export const GET_BANCO = "getBanco";
export const CREATE_BANCO = "createBanco";
export const UPDATE_BANCO = "updateBanco";
export const DELETE_BANCO = "deleteBanco";
export const ACTUALIZAR_ESTADO_BANCO = "desactivarBanco"

//Mutadores
export const SET_BANCOS = "setBancos"
export const SET_BANCO = "setBanco"
export const SET_ERROR = "setError"

//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
// const url = "https://localhost:44340"

const state = {
    error: null,
    cajeros: []
}

const actions = {
    [GET_BANCOS](context) {
        
        return new Promise((resolve) => {
            ApiService.setHeader();
            ApiService.get({ action: '/facturacioncomisionapi/api/Banco/v1/Bancos'  }, "")
                .then(({ data }) => {
                    // context.commit(SET_BANCOS, data);
                    resolve(data)
                })
                .catch(({ response }) => {
                    //console.log(("error: " + response);
                    context.commit(SET_ERROR, "")
                })
        })
    },
    [GET_BANCO](context, banco) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.get({ action: `/facturacioncomisionapi/api/Banco/v1/Banco/${banco.bancoId}`  }, banco)
                .then(({ data }) => {
                    context.commit(SET_BANCO, data)
                    resolve(data)
                })
                .catch(({ reponse }) => {
                    //console.log(("Hubo un error al obtener el cajero asignado. mensaje interno: " + response)
                    context.commit(SET_ERROR, "")
                })
        })
    },
    [CREATE_BANCO](context, banco) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.post({ action: '/facturacioncomisionapi//api/Banco/v1/Banco/'  }, banco)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, {
                        error: ["No se pudo ingresar el cajero"]
                    });
                    reject(response)
                });
        });
    },
    [UPDATE_BANCO](contexto, banco) {
        return new Promise((resolve, reject) => {
            ApiService.put({ action: `/facturacioncomisionapi//api/Banco/v1/Banco/`  }, banco)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    [DELETE_BANCO](context, banco) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.delete({ action: `/facturacioncomisionapi//api/Banco/v1/Banco/${banco.bancoId}`  }, banco)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    [ACTUALIZAR_ESTADO_BANCO](context, banco){
        return new Promise((resolve, reject) => {
            ApiService.put({action: '/facturacioncomisionapi/api/Banco/v1/ActualizarEstado' }, banco)
            .then(({ data }) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            })
        })
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error
    },
    [SET_BANCOS](state, cajeros) {
        state.error = {};
        state.cajeros = cajeros
    }
}

export default {
    state,
    actions,
    mutations
}